/**
 * Trạng thái của form
 */
export default {
  Male: 1,
  Female: 0,
}
